import {
    createCourseStart,
    createCourseSuccess,
    createCourseFailure,
    updateCourseStart,
    updateCourseSuccess,
    updateCourseFailure,
    getAllCoursesStart,
    getAllCoursesSuccess,
    getAllCoursesFailure,
    getCourseByStart,
    getCourseBySuccess,
    getCourseByFailure,
    cleanSelectedCourse,
    getListStudentByIdCourseStart,
    getListStudentByIdCourseSuccess,
    getListStudentByIdCourseFailure,
    getListStudentsNotCourseSuccess,
    getCourseByIdentifierSuccess
} from '../reducers/course';

import axios, { axiosPrivate } from '../../api/axios';
import { toast } from 'react-hot-toast';

const toObjectId = (value) => {
    if (!value) return undefined;
    if (typeof value === 'string') return value;
    return value._id || undefined;
};

export const createCourse = ({
    identifier,
    language,
    level,
    color,
    limitMembers,
    fromDate,
    toDate,
    hours,
    days,
    teacher,
    headerImage,
    moderator,
    zoomEnabled,
}) => async (dispatch) => {
    try {
        dispatch(createCourseStart());
        const response = await axiosPrivate.post(`/course`, {
            identifier: identifier?.trim(),
            language: toObjectId(language),
            level: toObjectId(level),
            limitMembers: Number(limitMembers),
            fromDate,
            hours,
            days,
            teacher: toObjectId(teacher),
            toDate,
            color: toObjectId(color),
            headerImage: toObjectId(headerImage) || headerImage,
            moderator: toObjectId(moderator),
            zoomEnabled: zoomEnabled === true,
        });

        if (response.status === 201) {
            dispatch(createCourseSuccess(response.data));
            return {
                status: response.status || null,
                message: response.data.message
            }
            // toast.success(response.data.message);
        }
    } catch (error) {
        dispatch(createCourseFailure());
        return {
            status: error.response.status || null,
            message: error.response.data.message
        };
    }
};

export const updateCourse = ({
    id,
    identifier,
    language,
    level,
    color,
    limitMembers,
    fromDate,
    toDate,
    hours,
    days,
    teacher,
    headerImage,
    moderator,
    status,
    zoomEnabled,
}) => async (dispatch) => {
    try {
        dispatch(updateCourseStart());
        const response = await axiosPrivate.put(`/course/${id}`, {
            identifier,
            language: toObjectId(language),
            level: toObjectId(level),
            limitMembers: Number(limitMembers),
            fromDate,
            hours,
            days,
            teacher: toObjectId(teacher),
            toDate,
            color: toObjectId(color),
            headerImage: toObjectId(headerImage) || headerImage,
            moderator: toObjectId(moderator),
            status: status?._id || status,
            zoomEnabled: zoomEnabled === true,
        });

        if (response.status === 200) {
            dispatch(updateCourseSuccess());
            return {
                status: response.status || null,
                message: response.data.message
            }
            // toast.success(response.data.message);
        }
    } catch (error) {
        dispatch(updateCourseFailure());
        return {
            status: error.response.status || null,
            message: error.response.data.message
        };
    }
};

export const getAllCourses = (userId, roles) => async (dispatch) => {
    try {
        dispatch(getAllCoursesStart());

        const response = await axios.get(`/course/getAllCourse/${userId}/${roles}`);
        if (response.status === 200) {
            dispatch(getAllCoursesSuccess(response.data));
            return {
                status: response.status,
                totalRows: response.data.total,
                page: response.data.page,
                pageSize: response.data.pageSize
            };
        }
    } catch (error) {
        dispatch(getAllCoursesFailure());
        return {
            status: error.response.status || null,
            message: error.response.data.message
        };
    }
};

export const getAllCoursesByFilters = ({
    userId,
    roles,
    status,
    identifier,
    language,
    level,
    teacher,
    fromDate,
    toDate,
    days,
    sort,
    page,
    pageSize,
    usePagination,
    sendExcel
}) => async (dispatch) => {
    try {

        if (!sendExcel) {
            dispatch(getAllCoursesStart());
        }

        const params = `/course/getAllCourseByFilter?userId=${userId}&roles=${roles}&status=${status}&identifier=${identifier}&language=${language}&level=${level}&teacher=${teacher}&fromDate=${fromDate}&toDate=${toDate}&days=${days}&sort=${sort.value || 'desc'}&page=${page}&pageSize=${pageSize}&usePagination=${usePagination}&sendExcel=${sendExcel}`;

        const response = await axios.get(params);

        if (response.status === 200) {
            if (!sendExcel) {
                dispatch(getAllCoursesSuccess(response.data));
            }
            return {
                status: response.status,
                totalRows: response.data.total,
                page: response.data.page,
                pageSize: response.data.pageSize,
                excelData: response.data.excelData
            };
        }
    } catch (error) {
        if (!sendExcel) {
            dispatch(getAllCoursesFailure());
        }
        return {
            status: error.response.status || null,
            message: error.response.data.message
        };
    }
};

export const getCourseById = (idCourse) => async (dispatch) => {
    try {
        dispatch(getCourseByStart());

        const response = await axios.get(`/course/findCourseById/${idCourse}`);
        if (response.status === 200) {
            dispatch(getCourseBySuccess(response.data));
        }
    } catch (error) {
        dispatch(getCourseByFailure());
        toast.error('Ocurrio un error.')
    }
};
export const getCourseByIdentifier = (identifier) => async (dispatch) => {
    try {
        dispatch(getCourseByStart());

        const response = await axios.get(`/course/findCourseByIdentifier/${identifier}`);
        if (response.status === 200) {
            dispatch(getCourseByIdentifierSuccess(response.data));
        }
    } catch (error) {
        dispatch(getCourseByFailure());
        toast.error('Ocurrio un error.')
    }
};

export const cleanActionSelectedCourse = () => async (dispatch) => {
    dispatch(cleanSelectedCourse());
};

export const getListStudentsByIdCourse = (courseId) => async (dispatch) => {
    try {
        dispatch(getListStudentByIdCourseStart());

        const response = await axios.get(`/course/getListStudentsCourseById/${courseId}`);
        if (response.status === 200) {
            dispatch(getListStudentByIdCourseSuccess(response.data));
        }
    } catch (error) {
        dispatch(getListStudentByIdCourseFailure());
        toast.error('Ocurrio un error.')
    }
};

export const getListStudentsNotInCourse = (courseId) => async (dispatch) => {
    try {
        dispatch(getListStudentByIdCourseStart());

        const response = await axios.get(`/course/getListStudentsNotInCourse/${courseId}`);
        if (response.status === 200) {
            dispatch(getListStudentsNotCourseSuccess(response.data));
        }
    } catch (error) {
        dispatch(getListStudentByIdCourseFailure());
        toast.error('Ocurrio un error.')
    }
}

